import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const InputContainer = styled.div`
  padding-top: 24px;
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
